export default {
  addressLabel: "地址",
  tagAlt: "標籤",
  chainAlt: "鏈路",
  debugWidth: "我是寬度",
};
